<div
  class="charity-row"
  [class.charity-row--last]="isLastRow()"
  (click)="onCharityClick()"
  [attr.data-charity-uuid]="charity().organisationUuid">

  <!-- Contribute icon flipped 180 degrees (top right, visible on hover) -->
  <div class="charity-row__arrow">
    <app-icon name="contribute" [size]="20" color="#1A1A1A"></app-icon>
  </div>

  <!-- Charity Image -->
  <div class="charity-row__image-container">
    <img
      class="charity-row__image"
      [src]="charity().organisationLogoUrl"
      [alt]="charity().organisationName"
      loading="lazy">
  </div>

  <!-- Charity Content -->
  <div class="charity-row__content">
    <div class="charity-row__header">
      <div class="charity-row__title-section">
        <h3 class="charity-row__name">{{ charity().organisationName }}</h3>
        <!-- Category Badge -->
        @if (showCategoryBadge() && getCategoryName()) {
          <div class="charity-row__badge">
            <app-badge
              variant="category"
              [label]="getCategoryName()">
            </app-badge>
          </div>
        }
      </div>

      <!-- Mobile Give Button (top right, visible on mobile only) -->
      <div class="charity-row__give-button charity-row__give-button--mobile" (click)="onGiveButtonClick($event)">
        <app-button
          [label]="'Give'"
          [variant]="'yellow'"
          (clicked)="onGiveClick()">
        </app-button>
      </div>
    </div>
    <!-- Description and Give button side by side -->
    <div class="charity-row__footer">
      <p class="charity-row__description">{{ charity().executiveSummary }}</p>
      <div class="charity-row__give-button charity-row__give-button--desktop" (click)="onGiveButtonClick($event)">
        <app-button
          [label]="'Give'"
          [variant]="'yellow'"
          (clicked)="onGiveClick()">
        </app-button>
      </div>
    </div>
  </div>

  <!-- Separator Element -->
  @if (!isLastRow()) {
    <div class="charity-row__separator"></div>
  }
</div>
